import { render } from "./Ticks.vue?vue&type=template&id=9fe456b8&scoped=true&ts=true"
import script from "./Ticks.vue?vue&type=script&lang=ts"
export * from "./Ticks.vue?vue&type=script&lang=ts"

import "./Ticks.vue?vue&type=style&index=0&id=9fe456b8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fe456b8"]])

export default __exports__